import { createSlice } from "@reduxjs/toolkit";

const initialState = { value: { slug: 0, client_id : null } }; // Corrected the name to initialState

const selectedData = createSlice({
  name: "selectedData",
  initialState, // Use the key "initialState
  reducers: {
    setSelectedData: (state, action) => {
      state.value = action.payload; // Assuming you're updating the "value" field in the state
    },
    resetSelectedData: (state) => {
      state.value = initialState.value;
    },
    setSelectedClient: (state, action) => {
      state.value.client_id = action.payload;
    },
  },
});

export const { setSelectedData, resetSelectedData, setSelectedClient } = selectedData.actions;
export const selectedDataReducer = selectedData.reducer;
